import { useEffect } from "react"
import { useTranslation } from "react-i18next"
import wuloojMark from "assets/images/superadmin/wulooj-mark.png"
import { AUTH_BRAND } from "utils/authPlatform"

const DEFAULT_TITLE_EN = "WULOOJ Platform"

/**
 * Applies platform favicon + document title while the layout is mounted (authenticated super-admin session).
 */
const SuperAdminThemeBridge = () => {
  const { i18n } = useTranslation()

  useEffect(() => {
    const link =
      document.querySelector("link[rel='icon']") ||
      Object.assign(document.createElement("link"), { rel: "icon" })
    if (!link.parentNode) document.head.appendChild(link)

    const prevHref = link.getAttribute("href") || ""
    const prevTitle = document.title

    link.href = wuloojMark
    document.title =
      i18n.language === "sa"
        ? "منصة وُلوج"
        : `${DEFAULT_TITLE_EN} | ${AUTH_BRAND}`

    const metaTheme = document.querySelector("meta[name='theme-color']")
    const prevTheme = metaTheme?.getAttribute("content")
    if (metaTheme) metaTheme.setAttribute("content", "#AA90D3")

    return () => {
      if (prevHref) link.setAttribute("href", prevHref)
      document.title = prevTitle
      if (metaTheme && prevTheme !== undefined)
        metaTheme.setAttribute("content", prevTheme || "#000000")
    }
  }, [i18n.language])

  return null
}

export default SuperAdminThemeBridge
